// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_jp-j";
export var fulfillmentFormRail = "_jp-i";
export var headerTitleRow = "_jp-l";
export var orderDetailsWrapper = "_jp-g";
export var orderLinkTrigger = "_jp-2";
export var paymentInformationGrid = "_jp-q";
export var paymentSummaryColumn = "_jp-r";
export var phoneShipmentPickerButton = "_jp-e";
export var phoneShipmentPickerButtonContent = "_jp-f";
export var phoneShipmentPickerButtonWrapper = "_jp-d";
export var phoneShipmentPickerTrigger = "_jp-c";
export var shipmentContainer = "_jp-k";
export var shipmentDetailsMainPane = "_jp-h";
export var shipmentNavigationCard = "_jp-a";
export var shipmentNavigationEdgeTrigger = "_jp-6";
export var shipmentNavigationRail = "_jp-3";
export var shipmentNavigationRailEnter = "_jp-5";
export var shipmentNavigationRailHeader = "_jp-9";
export var shipmentNavigationRailOverlay = "_jp-4";
export var shipmentNavigationScrim = "_jp-7";
export var shipmentSummaryFact = "_jp-n";
export var shipmentSummaryGrid = "_jp-m";
export var shipmentSummaryMetadataRow = "_jp-o";
export var shipmentSummaryTags = "_jp-p";
export var shipmentWorkspace = "_jp-0";
export var shipmentWorkspaceBodyTablet = "_jp-8";
export var shipmentWorkspaceContent = "_jp-b";
export var shipmentWorkspaceHeader = "_jp-1";